import * as Yup from 'yup';

export const ClassSchema = Yup.object({
  className: Yup.string().required('Class Name is required'),

  classTitle: Yup.string().nullable(),

  classTeacher: Yup.string()
    .required('Class Teacher name is required')
    .min(3, 'Teacher name must be at least 3 characters'),

  classTeacherPhoneNumber: Yup.string()
    .required('Teacher phone number is required')
    .matches(/^[0-9]{10,15}$/, 'Enter a valid phone number'),

  classType: Yup.string().required('Class Type is required'),
});
